"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisabledDays = exports.bookingNextYearsCount = exports.bookingFilterPastYearsCount = exports.bookingPastYearsCount = exports.defaultNextYearsCount = exports.defaultPastYearsCount = exports.defaultPastYear = void 0;
const moment_1 = __importDefault(require("moment"));
exports.defaultPastYear = 1900;
exports.defaultPastYearsCount = (new Date()).getFullYear() - exports.defaultPastYear;
exports.defaultNextYearsCount = 0;
exports.bookingPastYearsCount = 1;
exports.bookingFilterPastYearsCount = 15;
exports.bookingNextYearsCount = 3;
const getDisabledDays = (restrictions) => ([
    (restrictions === null || restrictions === void 0 ? void 0 : restrictions.disabledBeforeDay) ? { before: (0, moment_1.default)(restrictions.disabledBeforeDay).toDate() } : undefined,
    (restrictions === null || restrictions === void 0 ? void 0 : restrictions.disabledAfterDay) ? { after: (0, moment_1.default)(restrictions.disabledAfterDay).toDate() } : undefined,
    (restrictions === null || restrictions === void 0 ? void 0 : restrictions.disablePastDays) ? { before: (0, moment_1.default)().toDate() } : undefined,
    (restrictions === null || restrictions === void 0 ? void 0 : restrictions.disableFutureDays) ? { after: (0, moment_1.default)().toDate() } : undefined,
]);
exports.getDisabledDays = getDisabledDays;
//# sourceMappingURL=common.js.map